<template>
    <div class="row justify-content-center">
        <div class="col-md-5">
            <div class="card">
                <Loading v-if="showLoading" />
                <div class="card-body">
                    <form v-on:submit.prevent="submit">
                        <h5 class="text-right mb-2">تغییر رمز عبور</h5>
                        <div class="form-group text-right" v-if="!otpSent">
                            <label>شماره همراه</label>
                            <input class="form-control" dir="ltr" type="tel" maxlength="11" v-model="phone">
                        </div>
                        <div class="form-group text-right" v-if="otpSent && !session">
                            <label>کد اعتبارسنجی</label>
                            <input class="form-control" dir="ltr" type="tel" maxlength="5" v-model="otp">
                        </div>
                        <div class="form-group text-right" v-if="otpSent && session">
                            <label>رمز عبور</label>
                            <input class="form-control" dir="ltr" type="password" v-model="password">
                        </div>
                        <div class="form-group text-right" v-if="otpSent && session">
                            <label>تکرار رمز عبور</label>
                            <input class="form-control" dir="ltr" type="password" v-model="repeatPassword">
                        </div>
                        <div class="captcha-container mt-4 mb-4" style="text-align: center">
                            <img :src="captchaImage" class="captcha-image">
                            <i class="si si-reload" data-toggle="tooltip" @click="createCaptcha" style="font-size: 30px;position: relative;top: 11px;margin-right: 10px;cursor: pointer" data-original-title="si-reload"></i>
                        </div>
                        <div class="form-group text-right">
                            <label>کد امنیتی</label>
                            <input type="text" class="form-control ltr-input" v-model="captcha" maxlength="6">
                        </div>
                        <button class="btn ripple btn-main-primary btn-block mb-3">تغییر رمز عبور</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    name: 'ChangePassword',
    data(){
        return {
            showLoading: false,
            phone: '',
            session: '',
            otpSent: false,
            otp: '',
            password: '',
            repeatPassword: '',
            captcha: '',
            captchaImage: ''
        }
    },
    methods: {
        submit(){
            this.showLoading = true;
            if(!this.otpSent){
                const postedData = {
                    phone: this.phone.replace('-','')
                };
                this.$api.post('user/RequestReset',postedData,{headers: {captcha: this.captcha}}).then(({data}) => {
                    if(data.status){
                        this.otpSent = true;
                        this.captcha = '';
                        this.createCaptcha();
                        this.$toast.success('کد اعتبارسنجی با موفقیت به شماره همراه شما ارسال شد');
                    }
                }).catch(({response}) => {
                    response.data.errors.map(err => this.$toast.error(err.message));
                }).finally(() => {
                    this.createCaptcha();
                    this.showLoading = false;
                });
            }else if(this.otpSent && !this.session){
                const postedData = {
                    phone: this.phone.replace('-',''),
                    verificationCode: this.otp
                };
                this.$api.post('user/ObtainSession',postedData,{headers: {captcha: this.captcha}}).then(({data}) => {
                    if(data.status){
                        this.session = data.result.sessionId;
                        this.captcha = '';
                        this.createCaptcha();
                        this.$toast.success('رمز عبور جدید خود را وارد کنید');
                    }
                    else{
                        this.$toast.error('کد وارد شده معتبر نمی‌باشد');
                        this.createCaptcha();
                    }
                }).catch(({response}) => {
                    response.data.errors.map(err => this.$toast.error(err.message));
                }).finally(() => {
                    this.showLoading = false;
                });
            }else if(this.otpSent && this.session){
                const postedData = {
                    password: this.password,
                    passwordConfirm: this.repeatPassword,
                    sessionId: this.session
                };
                this.$api.post('user/ChangePassword',postedData).then(({data}) => {
                    if(data.status){
                        this.$toast.success('رمز عبور شما با موفقیت تغییر کرد');
                        this.$router.push({name: 'login'});
                    }
                }).catch(({response}) => {
                    response.data.errors.map(err => this.$toast.error(err.message));
                }).finally(() => {
                    this.showLoading = false;
                });
            }
        },
        async createCaptcha(){
            let imgSrc = await this.generateCaptcha();
            this.captchaImage = imgSrc || this.captchaImage;
        }
    },
    created(){
        this.createCaptcha();
    }
}
</script>